import * as apiDelete from 'api/channel/DeleteChannelIdV1';
import * as apiRestore from 'api/channel/PostChannelRestoreV1';
import * as apiPostSearch from 'api/channel/PostChannelSearchV1';

export default class Channel {
	public id: string = '';
	public name: string = '';
	public iconSvgUrl: string | null = null;

	public constructor(input?: apiPostSearch.ResponseChannel) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiDelete(): Promise<void> {
		await apiDelete.callApi(this.id);
	}

	public async callApiRestore(): Promise<void> {
		await apiRestore.callApi(this.id);
	}

	private mapFromApi(input: apiPostSearch.ResponseChannel) {
		this.id = input.id;
		this.name = input.name;
		this.iconSvgUrl = input.iconSvgUrl;
	}
}
